module.exports = __webpack_public_path__ + "static/media/ca-cover@2x.34bcf114.png";